import axios from "axios";
import { toggleFeaturedProjectUrl } from "../../utils";

export const toggleFeaturedProject = (id: string) => {
  return axios.post(toggleFeaturedProjectUrl(id));
};
